export default "__VITE_ASSET__BkO6$Lk7__"